<template>
  <div class="body">
    <div style="flex-direction: column;"
         v-if="etcData.length === 0 && !isLoading">
      <img :src="require('@/assets/skins/'+platformInfo.skin+'/idphoto_null@3x.png')"
           class="ect-no" />
      <div style="width:100%;justify-content: center;margin-top:-70px;color:#999999;font-size:.13rem;">您当前还没有证件照哦~</div>
      <div style="width:100%;justify-content: center;margin-top:40px;">
        <div :class="`btn bg_${platformInfo.skin} br_${platformInfo.skin}`"
             @click="routerHot">立即拍摄</div>
      </div>
    </div>
    <div v-if="etcData.length > 0 && !isLoading"
         style="flex-direction: column;">
      <div class="data-tip">{{list_hint}}</div>
      <div v-for="(item,index) in etcData"
           :key="index"
           style="width:100%;justify-content: center;">
        <div class="data-item"
             v-bind:style="index!==0?'margin-top:20px;':''"
             @click="toEtc(item)">
          <div class="data-item-body">
            <div style="height:20px;font-size:.13rem;color:#999999;"
                 class="fix-1px">订单编号:{{item.order_id}}</div>
            <div style="align-items:center">
              <div class="item-name"
                   style="flex-direction: column;">
                <div class="item-name-fo">{{item.spec_name}}</div>
                <div class="item-time">{{item.pay_time}}</div>
              </div>
              <img :src="item.final_pic_name[0]"
                   class="item-img"
                   :class="[item.type==='marriage'?'weddingimg':'']" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
  data () {
    return {
      etcData: [],
      list_hint:'温馨提示:本应用不提供照片的永久存储功能，电子照自付款成功之日7天后会自动删除，请尽早提取!'
    }
  },
  computed:{
    ...mapState(["isLoading","platformInfo","actiBol"])
  },
  methods: {
    ...mapActions(["getElelist","getListHintA"]),
    routerHot () { 
      this.$router.push({ name: 'search' })
    },
    toEtc (item) {
      this.$router.push({ name: 'etcDetail', params:{eleorder:item} })
    }
  },
  activated(){
    this.actiBol&&this.getElelist().then(res=>{
      let { data:{result:etcData} } = res;
      this.etcData = etcData;
    })
    this.actiBol&&this.getListHintA().then(res=>{
      let {list_hint} = res.data
      this.list_hint=list_hint
    })
  }
}
</script>

<style scoped>
.nor-bg-color {
  background-color: #4480e7;
}
div {
  display: flex;
}
.body {
  width: 100%;
  flex-direction: column;
}

.print-item {
  width: 3.55rem;
  height: 2.21rem;
  background-color: #ffffff;
  border-radius: 0.04rem;
  justify-content: center;
  align-items: center;
}
.item-name {
  height: 1.1rem;
  overflow: hidden;
  flex-grow: 1;
}

.item-name-fo {
  display: block;
  margin-top: 0.15rem;
  height: 0.48rem;
  width: 100%;
  font-size: 0.17rem;
  color: #333333;
  line-height: 0.48rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-time {
  margin-top: 0.1rem;
  font-size: 0.13rem;
  height: 0.35rem;
  color: #999999;
  width: 100%;
}
.item-img {
  /* margin-left:100px;  */
  margin-left: 0.5rem;
  width: 0.8rem;
  height: 1.05rem;
  object-fit: cover;
}
.data-item-body {
  height: 1.4rem;
  width: 3.25rem;
  flex-direction: column;
}
.data-item {
  width: 3.55rem;
  height: 1.7rem;
  background-color: #ffffff;
  border-radius: 0.04rem;
  justify-content: center;
  align-items: center;
}
.data-tip {
  width: 100%;
  /* height: 0.45rem; */
  padding:0.1rem;
  box-sizing: border-box;
  word-break: break-all;
  background-color: #fff9f0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.13rem;
  color: #f5a623;
}
.btn {
  width: 1.6rem;
  height: 0.45rem;
  /* border-radius: 0.23rem; */
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 0.13rem;
}

.ect-no {
  width: 100%;
}
.weddingimg{
  width:1.5rem;
  margin-left: 0;
  flex-shrink: 0;
  object-fit: contain;
}
</style>
